import { render, staticRenderFns } from "./RacingOddsComparisonTableDesktop.vue?vue&type=template&id=75917679"
import script from "./RacingOddsComparisonTableDesktop.vue?vue&type=script&lang=js"
export * from "./RacingOddsComparisonTableDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports